import React from 'react';

import './typing-dots.styles.scss';

const TypingDots = () => (
    <div id="wave">
        <span className="dot"></span>
        <span className="dot"></span>
        <span className="dot"></span>
    </div>
)

export default TypingDots;